/**
 * Tiers de precio para compra individual (single_purchase).
 *
 * Cada tier corresponde a un producto registrado en App Store Connect
 * bajo el bundle `com.sendadevida.app`. El `store_product_id` también
 * es el identificador que usa RevenueCat y el .storekit file local.
 *
 * Precios confirmados por Eduardo (16 Abr 2026): la versión física
 * del libro cuesta (ej) $7.50 → digital $7.99.
 */
export type PricingTier = {
  id: string;
  label: string;
  price: number;
  storeProductId: string;
};

export const PRICING_TIERS: PricingTier[] = [
  { id: "tier1", label: "Tier 1 — $7.99", price: 7.99, storeProductId: "com.sendadevida.app.book.tier1" },
  { id: "tier2", label: "Tier 2 — $9.99", price: 9.99, storeProductId: "com.sendadevida.app.book.tier2" },
  { id: "tier3", label: "Tier 3 — $10.99", price: 10.99, storeProductId: "com.sendadevida.app.book.tier3" },
  { id: "tier4", label: "Tier 4 — $13.99", price: 13.99, storeProductId: "com.sendadevida.app.book.tier4" },
  { id: "tier5", label: "Tier 5 — $17.99", price: 17.99, storeProductId: "com.sendadevida.app.book.tier5" },
  { id: "tier6", label: "Tier 6 — $18.99", price: 18.99, storeProductId: "com.sendadevida.app.book.tier6" },
];

/** Lookup tier by store_product_id (for loading existing rules). */
export function tierByStoreProductId(id: string | null | undefined): PricingTier | null {
  if (!id) return null;
  return PRICING_TIERS.find((t) => t.storeProductId === id) ?? null;
}

/** Fallback: lookup tier by exact price (for legacy rules that only had price). */
export function tierByPrice(price: number | null | undefined): PricingTier | null {
  if (price == null) return null;
  return PRICING_TIERS.find((t) => t.price === Number(price)) ?? null;
}
